import { useState } from 'react';
import { Button, Card, Checkbox, Col, Divider, Flex, Form, Input, Row, Switch } from 'antd';
import type { FormProps } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

// services
import NotificationService from 'core/services/notification';

// components
import PageTitle from 'components/title/title';
import FormElement from 'components/formElement/formElement';
import PhoneInputComponent, { PhoneInputReturn } from 'components/phoneInput/phoneInput';
import { checkPhoneValidation } from 'utils/validators/phone';
import SelectElement from 'components/selectElement/selectElement';
import DatePickerElement from 'components/datePicker/datePicker';
import { NATIONALITIES } from 'utils/nationalities';
import { isRTL } from 'core/services/language';
import StatusComponent from 'components/status/status';
import Icon from 'utils/icon';
import DisabledElement from 'components/disabledElement/disabledElement';
import dayjs from 'dayjs';
import BackButton from 'components/backButton/backButton';
import styles from '../mortgage.module.scss';

function BusinessMortgageActivitiesPage() {
	const navigate = useNavigate();
	const { t } = useTranslation();

	const [availableShares, setAvailableShares] = useState<number>(57);
	const [isReleaseLoading, setIsReleaseLoading] = useState(false);

	type createFieldType = {
		commercial_reg: number;
		name: string;
		phone: number;
		national_id: number;
		board: string;
		executive: boolean;
		birthdate: string;
		nationality: string;
		founder: boolean;
	};

	return (
		<>
			<PageTitle name={t('TITLE.CREATE_MORTGAGE')} />

			<BackButton />

			<Card className="mt-3">
				<div className="mb-3">
					<Flex align="center" gap={20}>
						<h5 className="mb-0">{t('MORTGAGE.REQUEST')} #123456</h5>
						<StatusComponent small text={t('COMMON.ACTIVE')} color="green" />
					</Flex>
					<p className="text-light">30th June, 3:00PM</p>
				</div>

				<Row gutter={[16, 16]}>
					<Col span={24} md={12}>
						<FormElement disabled fullWidth type="number" name="nationalId" label={t('COMMON.NATIONAL_ID')} rules={[{ required: true }]} />
					</Col>
				</Row>
			</Card>

			<Card className="mt-4 px-4 customCard">
				<div className={styles.activities}>
					<Flex justify="space-between" align="center" gap={20} className="px-2 py-4">
						<h5 style={{ marginInlineStart: 15 }}>{t('MORTGAGE.ACTIVITY_LOG')}</h5>
						<Button variant="outlined" color="primary" size="middle">
							<Icon name="download" color="var(--primary)" />
							<span>{t('COMMON.DOWNLOAD')}</span>
						</Button>
					</Flex>

					{[1, 2, 3, 4, 5].map((item) => (
						<div className={styles.activities_item}>
							<Flex align="center" gap={20}>
								<Icon name="user" width={35} height={35} />
								<h6 className="mb-0">20th Nov, 6:00PM</h6>
							</Flex>

							<Flex align="center" gap={20} className={styles.activities_item_type}>
								<StatusComponent small text="Action type" color="green" />
								<StatusComponent small text="User name : Abanob" color="green" />
							</Flex>

							<Flex wrap align="center" gap={10} className={styles.activities_item_data}>
								<Icon name="greenPoint" width={40} height={10} style={{ transform: isRTL() ? 'rotateY(180deg)' : 'none' }} />
								<span>20th Nov, 6:02PM</span>
								<DisabledElement value="data" style={{ marginBottom: 0, marginInlineStart: 10, width: '500px', maxWidth: '90%' }} />
							</Flex>

							<Flex wrap align="center" gap={10} className={styles.activities_item_data}>
								<Icon name="redPoint" width={40} height={10} style={{ transform: isRTL() ? 'rotateY(180deg)' : 'none' }} />
								<span>20th Nov, 6:02PM</span>
								<DisabledElement value="data" style={{ marginBottom: 0, marginInlineStart: 10, width: '500px', maxWidth: '90%' }} />
							</Flex>
						</div>
					))}
				</div>
			</Card>
		</>
	);
}

export default BusinessMortgageActivitiesPage;
